import React from 'react'
import { CabinTypesContext } from './CabinTypesProvider'

const useCabinTypesState = () => {
    return React.useContext(CabinTypesContext)
}

export default useCabinTypesState
